module.exports = __webpack_public_path__ + "static/media/link1.fb9c92eb.svg";